// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2PjEL","inputWrap":"styles_inputWrap__1rTc2","input":"styles_input__WaeLt"};